import { BASE_URL } from '../../../Constant';

export const API_CREATE_DOCUMENT_TEMPLATE_TRANSLATION: string = `${BASE_URL}/document/template/translation`;
export const API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION: string = `${BASE_URL}/document/template/translation/update`;
export const API_UPDATE_DOCUMENT_TEMPLATE_TRANSLATION_STATUS: string = `${BASE_URL}/document/template/translation/changeStatus`;
export const GET_SINGLE_DOCUMENT_TEMPLATE_TRANSLATION = (
    documentTemplateId: number,
    languageId: number,
): string =>
    `${BASE_URL}/document/template/translation/${documentTemplateId}/${languageId}`;
export const API_IS_OTHER_TRANSLATION_EXISTS = (
    documentTemplateId: number,
    languageId: number,
): string =>
    `${BASE_URL}/document/template/translation/isOtherTranslationExists/${documentTemplateId}/${languageId}`;
export const API_IS_URL_EXISTS: string = `${BASE_URL}/document/template/translation/isUrlExist`;
export const API_DESCRIPTION_EDITOR_IMAGE_UPLOAD: string = `${BASE_URL}/document/template/translation/descriptionEditorFileUpload`;

export const DOCUMENT_TEMPLATE_TRANSLATION_STATUS_ACTIVE: number = 1;
export const DOCUMENT_TEMPLATE_TRANSLATION_STATUS_INACTIVE: number = 2;
export const DOCUMENT_TEMPLATE_TRANSLATION_STATUS_DELETED: number = 10;

export const API_DOCUMENT_TEMPLATE_TRANSLATION_IMAGE_UPLOAD: string = `${BASE_URL}/document/template/translation/imageFileUpload`;

export const API_DOWNLOAD_DOCUMENT_TEMPLATE_PDF = (documentTemplateTranslationId: number): string => 
    `${BASE_URL}/document/template/translation/downloadDocumentTemplatePdf/${documentTemplateTranslationId}`;

export const API_DELETE_DOCUMENT_TEMPLATE_PDF = (documentTemplateTranslationId: number): string => 
    `${BASE_URL}/document/template/translation/deleteDocumentTemplatePdf/${documentTemplateTranslationId}`;
